import { Row } from 'react-table';
import _ from 'lodash';
import { DateService } from 'Services';

/**
 * A majority of this file was ripped off of the react-table sortTypes on github
 * Minor modifications were made so that we could handle situations like
 * datetime being null/undefined.
 */
const reSplitAlphaNumeric = /([0-9]+)/gm;

const getRowValueByColumnId = <D extends object = {}>(row: Row<D>, columnId: string) => row.values[columnId];

function compareBasic(a: any, b: any) {
    // eslint-disable-next-line
    return a === b ? 0 : a > b ? 1 : -1;
}

function toString(a: number | undefined | string) {
    if (typeof a === 'number') {
        if (_.isNaN(a) || a === Infinity || a === -Infinity) {
            return '';
        }
        return String(a);
    }
    if (typeof a === 'string') {
        return a;
    }
    return '';
}

// Mixed sorting is slow, but very inclusive of many edge cases.
// It handles numbers, mixed alphanumeric combinations, and even
// null, undefined, and Infinity
export const alphanumeric = <D extends object = {}>(rowA: Row<D>, rowB: Row<D>, columnId: string) => {
    // const columnA = _.find(rowA.cells, (cell) => cell.column.id === columnId);
    let a = getRowValueByColumnId(rowA, columnId);
    let b = getRowValueByColumnId(rowB, columnId);
    // Force to strings (or "" for unsupported types)
    a = toString(a).toLowerCase();
    b = toString(b).toLowerCase();

    // Split on number groups, but keep the delimiter
    // Then remove falsey split values
    a = a.split(reSplitAlphaNumeric).filter(Boolean);
    b = b.split(reSplitAlphaNumeric).filter(Boolean);

    // While
    while (a.length && b.length) {
        const aa = a.shift();
        const bb = b.shift();

        const an = parseInt(aa, 10);
        const bn = parseInt(bb, 10);

        const combo = [an, bn].sort();

        // Both are string
        if (_.isNaN(combo[0])) {
            if (aa > bb) {
                return 1;
            }
            if (bb > aa) {
                return -1;
            }
            // eslint-disable-next-line no-continue
            continue;
        }

        // One is a string, one is a number
        if (_.isNaN(combo[1])) {
            return _.isNaN(an) ? -1 : 1;
        }

        // Both are numbers
        if (an > bn) {
            return 1;
        }
        if (bn > an) {
            return -1;
        }
    }

    return a.length - b.length;
};

export const datetime = <D extends object = {}>(rowA: Row<D>, rowB: Row<D>, columnId: string) => {
    let a = getRowValueByColumnId(rowA, columnId);
    let b = getRowValueByColumnId(rowB, columnId);

    a = DateService.dateOrNull(a)?.getTime();
    b = DateService.dateOrNull(b)?.getTime();

    // both equal so return 0
    if (a === undefined && b === undefined) return 0;
    // a greater than b
    if (a === undefined && b !== undefined) return 1;
    // b greater than a
    if (b === undefined && a !== undefined) return -1;

    return compareBasic(a, b);
};
